import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextImage } from '@prismicio/next';
import clsx from 'clsx';
import Link from '@/components/atoms/Link';
import { ContentRelationshipItemLinkFieldExtended } from '@/prismicCustomTypes';
const SubDropdownItem = t0 => {
  const $ = _c(8);
  const {
    items,
    grid,
    hideMenu
  } = t0;
  const t1 = grid ? "xl:grid-cols-2" : "grid-cols-1";
  let t2;
  if ($[0] !== t1) {
    t2 = clsx("mt-5 grid gap-x-8 gap-y-6", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== hideMenu || $[3] !== items) {
    t3 = items?.map((t4, index) => {
      const {
        data
      } = t4;
      return <Link onClick={() => hideMenu()} href={data?.link?.url || ""} className="flex hover:opacity-50" key={index}><PrismicNextImage fallbackAlt="" className="mr-4 h-6 w-6" field={data?.icon} /><div><h3 className="text-body-7 font-semibold text-gray-600">{data?.title}</h3><p className="text-h10 hidden text-gray-500 xl:block">{data?.description}</p></div></Link>;
    });
    $[2] = hideMenu;
    $[3] = items;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className={t2} data-sentry-component="SubDropdownItem" data-sentry-source-file="index.tsx">{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default SubDropdownItem;